import { Location } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Injector, Input, isDevMode, Output } from '@angular/core';
import { DefaultUrlSerializer, Router } from '@angular/router';
import { CatalogContentAndSearchResolver } from 'src/core-lib/navigation/services/content.resolver';
import { SerializerUtil } from 'src/utils/serializer.util';
import { UrlUtil } from 'src/utils/url.util';

@Component({
    selector: 'pagination-page',
    templateUrl: './pagination-page.component.html',
    styleUrls: ['./pagination-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,

})
export class PaginationPageComponent {

    private se: DefaultUrlSerializer = new DefaultUrlSerializer();

    navigateablePages: number[];
    prev?: number;
    next?: number;
    _max: number = -1;
    _from: number = -1;
    _size: number = -1;
    hasMoreNextPages: boolean;
    hasMorePrevPages: boolean;
    pageFromUrl: number;
    maxPage: number;
    current: any;


    @Input()
    set max(max: number) {
        this._max = max;
        this._update();
    }

    @Input()
    set from(from: number) {
        this._from = from;
        this._update();
    }

    @Input()
    set size(size: number) {
        this._size = size;
        this._update();
    }

    @Input()
    state: 'pending' | 'error' | 'success';

    @Input()
    pagesShown: number = 5;

    @Output()
    update: EventEmitter<void>;

    constructor(
        private _detector: ChangeDetectorRef,
        private _location: Location,
        private _router: Router,
        private _productSearchService: CatalogContentAndSearchResolver,
    ) {
        this.update = new EventEmitter<void>();
        this._size = 48;
        this._from = +(new URL(window.location.href).searchParams.get(UrlUtil.PAGE_PREFIX)) * this._size;
    }

    updateUrl(from: number) {
        var search = new URL(window.location.href).searchParams;
        if (from - 1 > 0)
            search.set(UrlUtil.PAGE_PREFIX, (from - 1).toString());
        else
            search.delete(UrlUtil.PAGE_PREFIX);
        var _url = UrlUtil.safeUrl(search);
        var route = SerializerUtil.serialize(_url);
        this._location.replaceState(route);
        this._router.getCurrentNavigation();
        this._productSearchService.search(this._productSearchService.urlModel(_url.href),1).then(() => window.document.querySelector('app-catalog-search-layout')?.scrollIntoView());

    }

    private _update() {
        [
            this.navigateablePages,
            this.next,
            this.prev,
            this.maxPage,
            this.current,
        ] = this._updateButtons(this._max, this._from, this._size, this.pagesShown);
        this._detector.markForCheck();

    }

    private _updateButtons(_max: number, _from: number, _size: number, pagesShown: number) {
        if (_max === -1 ||
            _from === -1 ||
            _size === -1)
            return [[], false, false, null, null];

        let navigateablePages = [];
        let next = null;
        let prev = null;

        if (_max > _from + _size) {
            next = (_from + _size * 2) / _size;
        }

        if (_from > 0) {
            prev = (_from) / _size;
        }

        var start = _from / _size - 1;
        var maxPage = Math.ceil(_max / _size);
        var current = Math.ceil(_from / _size) + 1;
        if ((_max / _size - 5) < start)
            start = maxPage - 5;
        if (start < 1 || _max / _size < 5)
            start = 1;
        for (let index = start; index <= maxPage && navigateablePages.length < pagesShown; index++)
            navigateablePages.push(index);

        return [navigateablePages, next, prev, maxPage, current];
    }

}
